<div>
  <template v-if="!isEmbed">
    <!-- visibile solo durante una sessione di impersonificazione -->
    <banner-impersonificazione />
    <!-- Toolbar superiore -->
    <tool-bar @esci="esci" :utente="utente" :mail="mail" :menu="menu" @toggle-drawer="drawer = !drawer"></tool-bar>
  </template>

  <!-- Progress bar -->
  <v-progress-linear v-bind:indeterminate="true" v-show="loading" color="primary" class="mt-0 progress-bar" height="3">
  </v-progress-linear>

  <!-- Sidebar laterale sinistra: nascosta in modalità embed (webview di sistemi
       esterni), mostra solo il contenuto della pagina -->
  <left-bar v-if="!isEmbed" :menu="menu" :logo-url="logoUrl" v-model="drawer" @esci="esci"></left-bar>

  <!-- Sizes your content based upon application components -->
  <v-main class="pa-0">

    <!-- Provides the application the proper gutter -->
    <v-container fluid class="py-0">

      <router-view></router-view>
    </v-container>
  </v-main>

</div>